import React from "react";
import moment from "moment";
import "../../../css/table.css";
import ReactTable from "react-table";
import { connect } from "react-redux";
import { toArray, orderBy } from "lodash";
import ShiftForm from "../../../forms/ShiftForm.jsx";
import Modal from "../../../components/Modal/Modal.jsx";
import { db } from "../../../services/firebase";
import { resetForm } from "../../../ducks/Forms";
import SweetAlert from "react-bootstrap-sweetalert";
import NotificationSystem from "react-notification-system";
import Button from "../../../elements/CustomButton/CustomButton.jsx";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import SweetSpinner from "../../../components/SweetSpinner/SweetSpinner.jsx";
import { Col, Row, OverlayTrigger, Tooltip } from "react-bootstrap";
import { style as NotifyStyle } from "../../../variables/Variables.jsx";
import { faPencilAlt, faTrash } from "@fortawesome/fontawesome-free-solid";

class Shifts extends React.Component {
  constructor(props) {
    super(props);
    this.companyID = props.companyID;

    this.state = {
      fetchingShifts: true,
      shiftModal: false,
      targetShift: null,
      shifts: {},
      alert: null,
      _notificationSystem: null,
    };
  }

  componentDidMount() {
    this._fetchShifts();
    this.setState({ _notificationSystem: this.refs.notificationSystem });
  }

  render() {
    return (
      <div>
        {this.state.alert}
        {this.shiftModal()}
        <NotificationSystem ref="notificationSystem" style={NotifyStyle} />
        <Row>
          <Col md={12}>
            <Button
              bsStyle="default"
              wd
              className="pull-right"
              style={{ marginBottom: 10 }}
              onClick={() => {
                this.props.resetForm("ShiftForm");
                this.setState({ shiftModal: true, targetShift: null });
              }}
            >
              Adicionar Turno
            </Button>
          </Col>
        </Row>
        {this._renderShiftsTable(this.state.shifts)}
      </div>
    );
  }

  _fetchShifts = () => {
    const { companyID } = this.props;
    this.setState({ fetchingShifts: true });
    db.collection("companies")
      .doc(companyID)
      .collection("shifts")
      .onSnapshot((shiftSnapshot) => {
        if (!shiftSnapshot.empty) {
          const shifts = [];
          shiftSnapshot.forEach((shift) =>
            shifts.push({ ...shift.data(), id: shift.id })
          );
          this.setState({ fetchingShifts: false, shifts });
        } else {
          this.setState({ fetchingShifts: false });
        }
      });
  };

  _setShift = (values) => {
    this.setState({ shiftModal: false });
    this.waitAlert("Salvando dados", true);
    const { companyID } = this.props;
    db.collection("companies")
      .doc(companyID)
      .collection("shifts")
      .add({
        name: values.name,
        startAt: moment(values.startAt).format("H:mm"),
        endAt: moment(values.endAt).format("H:mm"),
      })
      .then(() => {
        this.hideAlert();
        this.notify("Turno adicionado", "success");
      })
      .catch((e) => {
        this.hideAlert();
        console.log(e);
        this.notify("Erro ao adicionar turno", "error");
      });
  };

  _updateShift = (shiftID) => (values) => {
    this.setState({ shiftModal: false });
    this.waitAlert("Atualizando dados", true);
    const { companyID } = this.props;
    const { name, startAt, endAt } = values;
    db.collection("companies")
      .doc(companyID)
      .collection("shifts")
      .doc(shiftID)
      .update({
        name,
        startAt:
          typeof startAt === "object"
            ? moment(startAt).format("H:mm")
            : startAt,
        endAt: typeof endAt === "object" ? moment(endAt).format("H:mm") : endAt,
      })
      .then(() => {
        this.hideAlert();
        this.notify("Turno atualizado", "success");
      })
      .catch((e) => {
        this.hideAlert();
        this.notify("Erro ao atualizar turno", "error");
      });
  };

  _remove = (id) => {
    this.hideAlert();
    this.waitAlert("Validando dados, aguarde", false);

    const { companyID } = this.props;

    db.collection("companies")
      .doc(companyID)
      .collection("results")
      .where("shift", "==", id)
      .get()
      .then((snap) => {
        if (snap.empty) {
          db.collection("users")
            .where("shift", "==", id)
            .get()
            .then((users) => {
              if (users.empty) {
                this.hideAlert();
                this.waitAlert("Removendo, aguarde", false);
                db.collection("companies")
                  .doc(companyID)
                  .collection("shifts")
                  .doc(id)
                  .delete()
                  .then(() => {
                    this.hideAlert();
                    this.notify("Turno removido", "success");
                  })
                  .catch((e) => {
                    this.hideAlert();
                    this.notify("Erro ao remover turno", "error");
                  });
              } else {
                this.hideAlert();
                this.notify(
                  "Um ou mais usuários fazem parte deste turno.",
                  "warning"
                );
              }
            });
        } else {
          this.hideAlert();
          this.notify(
            "Este turno possui ligações com os dados da empresa e não pode ser removido.",
            "warning"
          );
        }
      })
      .catch((e) => {
        this.hideAlert();
        this.notify("Erro ao remover turno", "error");
      });
  };

  shiftModal = () => {
    const { targetShift } = this.state;
    return (
      <Modal
        title={targetShift ? "Atualizar turno" : "Adicionar turno"}
        isOpen={this.state.shiftModal}
        content={
          <ShiftForm
            initialValues={targetShift}
            onSubmit={(values) => {
              targetShift
                ? this._updateShift(targetShift.id)(values)
                : this._setShift(values);
            }}
            handleCancel={() =>
              this.setState({ shiftModal: false, targetShift: null })
            }
          />
        }
      />
    );
  };

  _renderShiftsTable = (data) => (
    <ReactTable
      columns={[
        { Header: "Nome", accessor: "name" },
        { Header: "Início", accessor: "startAt" },
        { Header: "Conclusão", accessor: "endAt" },
        {
          Header: "Ações",
          accessor: "",
          Cell: ({ value }) => (
            <div style={{ textAlign: "center" }}>
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id={`edit_${value.id}`}>Editar</Tooltip>}
              >
                <a
                  className="btn btn-simple btn-default btn-icon"
                  onClick={() =>
                    this.setState({ targetShift: value, shiftModal: true })
                  }
                >
                  <FontAwesomeIcon className="text-dark" icon={faPencilAlt} />
                </a>
              </OverlayTrigger>
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id={`remove_${value.id}`}>Remover</Tooltip>}
              >
                <a
                  className="btn btn-simple btn-danger btn-icon"
                  onClick={() => this.removeAlert(value.id)}
                >
                  <FontAwesomeIcon icon={faTrash} />
                </a>
              </OverlayTrigger>
            </div>
          ),
        },
      ]}
      data={orderBy(toArray(data), ["name", "asc"])}
      onFetchData={this._fetchShifts}
      loading={this.state.fetchingShifts}
      defaultPageSize={10}
      className="-striped -highlight"
      previousText="Anterior"
      nextText="Próximo"
      loadingText="Carregando"
      noDataText="Nenhum turno encontrado"
      pageText="Página"
      ofText="de"
      rowsText="Registros"
    />
  );

  //Notifications
  notify = (message, level) => {
    this.state._notificationSystem.addNotification({
      title: null,
      message: <b>{message}</b>,
      level,
      position: "tr",
      autoDismiss: 4,
    });
  };

  //SweetAlerts
  hideAlert = () => this.setState({ alert: null });

  removeAlert = (id) => {
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block" }}
          title="Tem certeza?"
          onConfirm={() => this._remove(id)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="default"
          cancelBtnBsStyle="warning"
          confirmBtnText="Continuar"
          cancelBtnText="Cancelar"
          showCancel
        />
      ),
    });
  };

  waitAlert = (title, showSpinner) => {
    this.setState({
      alert: (
        <SweetAlert
          style={{ display: "block" }}
          title={title}
          onConfirm={() => null}
          showConfirm={false}
        >
          {showSpinner ? <SweetSpinner /> : null}
        </SweetAlert>
      ),
    });
  };
}

export default connect(null, { resetForm })(Shifts);



// WEBPACK FOOTER //
// ./src/views/Companies/Tabs/Shifts.jsx